import React from "react"
import types from "prop-types"
import { isEmpty } from "lodash-es"
import { useSelector } from "react-redux"
import { getClockFormat } from "reduxSlices/currentSettingsSlice"
import { orgLocalDateTimeByClockFormat } from "utils/dateHelpers"
import { ImpersonationBadge } from "shared/badges"
import { ProfileIcon } from "shared/icons"
import ItemRow from "shared/ItemRow"

const actorDescription = ({ impersonator, user, username }) => {
  if (isEmpty(user) && !username) return null

  const actorName = !isEmpty(user) ? user.attributionName : username

  if (isEmpty(impersonator)) return actorName

  return `${impersonator.impersonatorAttributionName} as ${actorName}`
}

// An audit written under a name rather than a user -- the system, or an authorization token --
// carries that name in username and no user.  An audit with neither is described without an actor.
const AuditItem = ({ audit }) => {
  const {
    createdAt, event, impersonator, user, username,
  } = audit

  const clockFormat = useSelector(getClockFormat)

  const hasUser = !isEmpty(user)
  const hasImpersonator = !isEmpty(impersonator)

  const actor = actorDescription({ impersonator, user, username })

  return (
    <ItemRow
      itemRowHeaderContent={(
        <>
          <div className="flex items-center gap-2 text-sm">
            {
              hasUser && <ProfileIcon user={user} />
            }
            <div className="flex items-center gap-1">
              {
                !actor
                  ? (
                    <span>The user was {event}.</span>
                  )
                  : (
                    <>
                      <span className="font-semibold">{actor}</span>
                      {
                        hasImpersonator && <ImpersonationBadge />
                      }
                      <span>{event} the user.</span>
                    </>
                  )
              }
            </div>
          </div>
          <span className="text-xs text-dark whitespace-nowrap">
            {orgLocalDateTimeByClockFormat(createdAt, clockFormat)}
          </span>
        </>
      )}
    />
  )
}

AuditItem.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  audit: types.object.isRequired,
}

export default AuditItem
